import { Modal, Alert, Button, Form } from '@deere/ux.uxframe-react'
import React from 'react'
import { useTranslation } from "react-i18next";
import { Typography } from "@deere/fuel-react";
import { TPSMEX } from '../../utils/surveyLiterals';

export default function TpsAgreementPopUp({handleClose,showAgreement, submitResponse, survey, signature}) {
    const { t } = useTranslation();
    
    const handleSubmit = event => {
        event.preventDefault();
        event.stopPropagation();
        
        submitResponse();
        handleClose();        
    }

    const isTPMEX = survey.code===TPSMEX? true: false; 
    return (<Modal show={showAgreement} onHide={handleClose} size="lg">
                <Form validated={true} onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('cm_lbl_agreemet_modal')}</Modal.Title>
                </Modal.Header>
                <Modal.Body scrollable={false} style={{maxHeight: '325px',overflowY: "auto"}}>
                    <Alert variant="warning">
                        <h5 className="uxf-alert-title" align="justify">
                            {t('tps_lbl_disclaimer_message')} 
                        </h5>
                    </Alert>
                    <br/>
                    { isTPMEX &&(
                        <Typography className="uxf-alert-title" align="justify" style={{marginLeft: "3rem"}}>
                            {t('tps_authorized_signature')}
                            <br/>
                            {signature} 
                        </Typography> 
                    )
                    }                    
    
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>{t('btn_cancel')}</Button>
                    <Button variant="primary" onClick={handleSubmit} type='submit'>{t('btn_review_submit')}</Button>
                </Modal.Footer>
                </Form>
            </Modal>)
}